import { base, jsonBase } from './endpoint'
import store from '@/store'

// 刷新登录
export const refreshToken = async () => {
    const res = await base()
    return await res.get(`refresh_token`, {headers: {'X-YC-RETOKEN': store.getters.tokens.refreshToken}})
}
export const login = async (data) => {
  const res = await base()
  return await res.post('login', data)
}

export const getJson = (url) => jsonBase.get(url)

export const getCode = async (phoneNo) => {
  const res = await base()
  return await res.get(`sms?phoneNo=${phoneNo}`)
}
// 获取用户详细信息
export const getOwnUser = async () => {
  const res = await base()
  return await res.get(`own`)
}
// 获取用户成绩列表  score_records
export const getScoreRecords = async () => {
  const res = await base()
  return await res.get(`score_records`)
}
// 获取预估位次
export const getRankingByScore = async (score) => {
  const res = await base()
  return await res.get(`rest/getRankingByScore?score=${score}`)
}
// 获取志愿梯次指数
export const getUserHotDegree = async (data) => {
  const res = await base()
  return await res.post('rest/getUserHotDegree', data)
}
// 保存用户成绩
export const saveScoreRecords = async (data) => {
  const res = await base()
  return await res.post('score_records', data)
}
// 上传excel
export const enrollExcelUpload = async (data) => {
  const res = await base()
  let formData = new FormData()
  formData.append('userId', data.userId)
  formData.append('score_record_id', data.score_record_id)
  formData.append('file_name', data.file_name)
  formData.append('file', data.file)
  return await res.post('rest/upload/enrollExcelUpload', formData)
}
// 获取志愿评测列表
export const getReportRecordList = async () => {
  const res = await base()
  return await res.get(`rest/getReportRecordList`)
}
// 获取志愿评测详情
export const getOverallAnalysis = async (data) => {
  const res = await base()
  return await res.post(`rest/analysis/overallAnalysis`, data)
}
// 点击专业详情
export const getSingleReportAnalyze = async (data) => {
  const res = await base()
  return await res.post(`rest/singleAnalysis`, data)
}
// 预请求
export const getReportExcelInfo = async (data) => {
  const res = await base()
  return await res.post(`rest/getReportExcelInfo`, data)
}
// 获取冲稳保字段
export const queryBelongedRankRegion = async (data) => {
  const res = await base()
  return await res.post(`/queryBelongedRankRegion`, data)
}
// 下载推荐结果
export const queryEnrollSchools = async (data) => {
  const res = await base()
  return await res.post(`queryEnrollSchools/v2`, data)
}
// 导出下载记录
export const getExcel = async (data) => {
  const res = await base()
  return await res.post(`getExcel`, data)
}
 
export default {
  refreshToken,
  login,
  getJson,
  getCode,
  getOwnUser,
  getScoreRecords,
  saveScoreRecords,
  enrollExcelUpload,
  getReportRecordList,
  getOverallAnalysis,
  getSingleReportAnalyze,
  getReportExcelInfo,
  getRankingByScore,
  getUserHotDegree,
  queryBelongedRankRegion,
  queryEnrollSchools,
  getExcel
}
